import {
  NgModule
} from '@angular/core';
import {
  ButtonsModule
} from '@progress/kendo-angular-buttons';
import {
  DateInputsModule
} from '@progress/kendo-angular-dateinputs';
import {
  DropDownsModule
} from '@progress/kendo-angular-dropdowns';
import {
  InputsModule
} from '@progress/kendo-angular-inputs';
import {GridModule} from '@progress/kendo-angular-grid';
import {ReactiveFormsModule} from '@angular/forms';
import {DialogModule} from '@progress/kendo-angular-dialog';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import {FlexLayoutModule} from '@angular/flex-layout';
import {MatExpansionModule} from '@angular/material/expansion';
import {SchedulerModule} from '@progress/kendo-angular-scheduler';
import {ProfileDialogComponent} from './profile-dialog.component';
import {LoadingIndicatorModule} from '../shared/layout/components/loading-indicator';
import {SharedCommonModule} from '../shared/common';
import {BreadcrumbModule} from '../shared/layout/components/breadcrumb';
import {ProfileComponent} from './profile.component';
import {FileSelectModule, UploadModule} from '@progress/kendo-angular-upload';
import {FloatingLabelModule} from '@progress/kendo-angular-label';
import {PasswordDialogComponent} from './password-dialog.component';
import {AvailabilityDialogComponent} from './availability-dialog.component';
import {BankAccountComponent} from '../bank/bank-account.component';

@NgModule({
  declarations: [
    ProfileComponent,
    ProfileDialogComponent,
    PasswordDialogComponent,
    AvailabilityDialogComponent
  ],
  imports: [
    ButtonsModule,
    DateInputsModule,
    GridModule,
    DropDownsModule,
    InputsModule,
    LoadingIndicatorModule,
    BreadcrumbModule,
    SharedCommonModule,
    ReactiveFormsModule,
    UploadModule,
    FloatingLabelModule,
    FileSelectModule,
    DialogModule,
    SchedulerModule,
    MatDialogModule,
    MatExpansionModule,
    MatIconModule,
    MatRadioModule,
    MatSelectModule,
    MatGridListModule,
    FlexLayoutModule,
  ],
  exports: [
  ],
  providers: [
  ],
  entryComponents: [
    ProfileDialogComponent,
    PasswordDialogComponent,
    AvailabilityDialogComponent,
    BankAccountComponent
  ],
})
export class ProfileModule {
}
